// extracted by mini-css-extract-plugin
export var active = "language-selector-module--active---Yf4b";
export var arrowIcon = "language-selector-module--arrowIcon--n5Cd6";
export var countryFlag = "language-selector-module--countryFlag--O5Iji";
export var countryLabel = "language-selector-module--countryLabel--I8CwT";
export var dropdownContent = "language-selector-module--dropdown-content--N0uGo";
export var languageSelectorMenu = "language-selector-module--languageSelectorMenu--V25cv";
export var menuButton = "language-selector-module--menuButton--TcRcu";
export var subMenuButton = "language-selector-module--subMenuButton--xzhH2";